import { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const isDev = process.env.NODE_ENV === "development";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function LoginDialog({ open, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { username, password });
      // Store access token in sessionStorage (safer than localStorage: not shared across tabs,
      // cleared on tab close, still auth-usable for cross-site cookie fallback)
      if (response.data.access_token) {
        sessionStorage.setItem("sbk_access_token", response.data.access_token);
      }
      toast.success("Sesión iniciada correctamente");
      onLoginSuccess(response.data.user);
      onClose();
    } catch (error) {
      if (isDev) console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Iniciar Sesión</DialogTitle>
          <DialogDescription>
            Ingresa tus credenciales para editar y eliminar puntos
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleLogin} className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="username">Usuario</Label>
            <Input
              id="username"
              data-testid="login-username"
              placeholder="Ingresa tu usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="rounded-xl"
              required
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              data-testid="login-password"
              type="password"
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-xl"
              required
            />
          </div>
          
          <div className="flex gap-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 rounded-full"
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              data-testid="login-submit"
              className="flex-1 bg-[#FF5A5F] hover:bg-[#E0484D] text-white rounded-full"
              disabled={loading}
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
